import { z } from 'zod';

export const educatorRoleSchema = z.enum([
  'shadow-teacher',
  'class-teacher',
  'special-educator',
  'school-counselor',
  'sport-coach',
]);

export const answerValueSchema = z.union([z.string(), z.array(z.string())]);
export const handbookAnswersSchema = z.record(answerValueSchema);

export const paymentIntentRequestSchema = z.object({
  childId: z.string().min(1),
  productId: z.string().min(1),
  amount: z.number().int().positive(),
  currency: z.string().length(3).optional().default('usd'),
});

export const paymentIntentResponseSchema = z.object({
  clientSecret: z.string().min(1),
  paymentIntentId: z.string().min(1),
});

export const generateHandbookRequestSchema = z.object({
  childId: z.string().min(1),
  productId: z.string().min(1),
  answers: handbookAnswersSchema,
});

export const generateHandbookResponseSchema = z.object({
  emailSent: z.boolean(),
});

export const entitlementStatusResponseSchema = z.object({
  status: z.enum(['none', 'pending', 'paid', 'fulfilled', 'failed', 'refunded']),
  emailedAt: z.string().nullable(),
  paidAt: z.string().nullable(),
});

export const resendHandbookRequestSchema = z.object({
  childId: z.string().min(1),
  productId: z.string().min(1),
});

export const resendHandbookResponseSchema = z.object({
  queued: z.boolean(),
});

export type PaymentIntentRequest = z.infer<typeof paymentIntentRequestSchema>;
export type HandbookAnswers = z.infer<typeof handbookAnswersSchema>;
export type GenerateHandbookRequest = z.infer<typeof generateHandbookRequestSchema>;
export type GenerateHandbookResponse = z.infer<typeof generateHandbookResponseSchema>;
export type EntitlementStatusResponse = z.infer<typeof entitlementStatusResponseSchema>;
export type ResendHandbookRequest = z.infer<typeof resendHandbookRequestSchema>;
export type ResendHandbookResponse = z.infer<typeof resendHandbookResponseSchema>;
